import {
  GridActionsCellItem,
  GridColumns,
  GridRowParams
} from '@mui/x-data-grid'
import { Row } from 'react-data-grid'
import { AiOutlineEye } from 'react-icons/ai'
import { FiTrash } from 'react-icons/fi'
import { HiOutlinePencil } from 'react-icons/hi'
import * as cadastroModelosActions from 'store/modules/backoffice/cadastroModelo/actions'

const headerTheme = 'table-header--purple'

export const COLUMNS: GridColumns<Row> = [
  {
    field: 'nome',
    headerName: 'Modelo',
    headerClassName: headerTheme,
    align: 'left',
    headerAlign: 'left',
    flex: 1
  },
  {
    field: 'descricao',
    headerName: 'Modelo cadastrado',
    headerClassName: headerTheme,
    align: 'left',
    headerAlign: 'left',
    flex: 1
  },
  {
    field: 'actions',
    headerName: 'Ações',
    headerClassName: headerTheme,
    type: 'actions',
    align: 'center',
    getActions: (params: GridRowParams) => [
      <GridActionsCellItem
        key={params.row.id}
        icon={<FiTrash />}
        label="Deletar"
        onClick={() => {
          cadastroModelosActions.setItemSelectedIdDispatch(params.row.id)
          cadastroModelosActions.toggleModalExclusaoDispatch(true)
        }}
      />,
      <GridActionsCellItem
        key={params.row.id}
        icon={<AiOutlineEye />}
        onClick={() => {
          cadastroModelosActions.visualizarModeloMensagemSagaDispatch(
            params.row.id
          )
        }}
        label="Visualizar"
      />,
      <GridActionsCellItem
        key={params.row.id}
        icon={<HiOutlinePencil />}
        onClick={() => {
          cadastroModelosActions.editarModeloMensagemSagaDispatch(params.row.id)
        }}
        label="Editar"
      />
    ]
  }
]
